import Select from "../../../../form/Select";
import React from "react";
import {optionsTemplate} from "../../../../../utils/formatters";

export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const {hidden, labels} = props;
    const inputProps = props.getProps("seller");
    return (hidden || []).indexOf("seller") === -1 && <Select
        label={labels.seller || "Eladó"}
        name="seller"
        component="partner"
        objectValue={true}
        labelKey="name"
        valueKey="partner_id"
        storeType="remote"
        optionsTemplate={optionsTemplate("partner")}
        {...inputProps}
        disabled={inputProps.disabled || propsTop.disabled}
        value={props.getValue("seller")}
        saveChanges={props.setFieldValue}
    />;
}